
<div class="val-simple-tree-view">
  <kendo-treeview [nodes]="items"
      textField="texte"
      kendoTreeViewExpandable
      kendoTreeViewHierarchyBinding
      childrenField="items"
      [expandedKeys]="itemsOuverts"
      [expandBy]="'identifiant'">
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
      <div class="val-simple-tree-view-item val-flex-conteneur">
        <val-simple-image width="16"
                          height="16"
                          [src]="RetournerIconeItem(dataItem)">
        </val-simple-image>
        <val-simple-libelle class="val-flex-1"
                            [libelle]="dataItem.texte">
        </val-simple-libelle>
      </div>
    </ng-template>
  </kendo-treeview>
</div>

